function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M9.77332 204.809L44.6617 207.915C45.3611 207.976 46.0605 207.812 46.6571 207.462L83.5408 185.863C83.9111 185.657 83.7877 185.081 83.3557 185.04L35.0345 174.919L9.77332 204.809Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-7.3006 192.733L29.6037 171.278C30.8791 170.537 32.4631 170.537 33.7385 171.278L49.7633 180.596C50.8535 181.234 50.833 182.777 49.7633 183.415L13.4761 204.377C11.9744 205.241 10.1436 205.241 8.6419 204.377L-7.3006 195.161C-8.2263 194.626 -8.2263 193.289 -7.3006 192.733Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.5861 176.976V182.098H42.3783L50.5861 176.976Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.7633 180.596L33.7385 171.278C32.4631 170.537 30.8791 170.537 29.6037 171.278L11.7687 181.646V204.953C12.3652 204.87 12.9412 204.665 13.4761 204.356L49.7633 183.415C50.8535 182.798 50.8535 181.234 49.7633 180.596Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-7.3003 187.817L29.604 166.361C30.8794 165.621 32.4634 165.621 33.7388 166.361L49.7636 175.68C50.8539 176.318 50.8333 177.861 49.7636 178.498L13.4764 199.46C11.9747 200.324 10.1439 200.324 8.64221 199.46L-7.3003 190.265C-8.22599 189.709 -8.22599 188.372 -7.3003 187.817Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-7.3006 183.723L29.6037 162.268C30.8791 161.527 32.4631 161.527 33.7385 162.268L49.7633 171.586C50.8535 172.224 50.833 173.767 49.7633 174.405L13.4761 195.346C11.9744 196.21 10.1436 196.21 8.6419 195.346L-7.3006 186.151C-8.2263 185.616 -8.2263 184.258 -7.3006 183.723Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.5861 167.966V173.088H42.3783L50.5861 167.966Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.7633 171.586L33.7385 162.268C32.4631 161.527 30.8791 161.527 29.6037 162.268L11.7687 172.636V195.942C12.3652 195.86 12.9412 195.654 13.4761 195.346L49.7633 174.405C50.8535 173.788 50.8535 172.224 49.7633 171.586Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-7.3003 178.807L29.604 157.351C30.8794 156.611 32.4634 156.611 33.7388 157.351L49.7636 166.67C50.8539 167.308 50.8333 168.85 49.7636 169.488L13.4764 190.429C11.9747 191.293 10.1439 191.293 8.64221 190.429L-7.3003 181.234C-8.22599 180.699 -8.22599 179.342 -7.3003 178.807Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-7.3006 173.623L29.6037 152.167C30.8791 151.427 32.4631 151.427 33.7385 152.167L49.7633 161.486C50.8535 162.124 50.833 163.667 49.7633 164.304L13.4761 185.246C11.9744 186.11 10.1436 186.11 8.6419 185.246L-7.3006 176.05C-8.2263 175.495 -8.2263 174.158 -7.3006 173.623Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.5861 157.866V162.988H42.3783L50.5861 157.866Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.7633 161.486L33.7385 152.167C32.4631 151.427 30.8791 151.427 29.6037 152.167L11.7687 162.535V185.842C12.3652 185.76 12.9412 185.554 13.4761 185.246L49.7633 164.304C50.8535 163.667 50.8535 162.103 49.7633 161.486Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-7.3003 168.706L29.604 147.251C30.8794 146.51 32.4634 146.51 33.7388 147.251L49.7636 156.57C50.8539 157.207 50.8333 158.75 49.7636 159.388L13.4764 180.329C11.9747 181.193 10.1439 181.193 8.64221 180.329L-7.3003 171.134C-8.22599 170.599 -8.22599 169.241 -7.3003 168.706Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.28422 170.866C7.07851 170.722 6.93451 170.496 6.93451 170.229V159.079C6.93451 159.079 7.05794 150.069 12.0155 144.104C16.9731 138.138 25.2633 134.476 30.0151 136.616C34.767 138.776 35.0962 143.918 35.0345 146.572C34.9728 148.876 35.0345 155.459 35.0345 157.228C35.0345 157.68 34.8493 158.112 34.4996 158.4C34.2733 158.586 33.9442 158.771 33.4916 158.894C32.8539 159.079 32.1545 159.079 31.4963 158.935C31.0231 158.832 30.4471 158.668 29.9946 158.4C29.5626 158.133 29.3157 157.66 29.3157 157.166V146.593C29.3157 146.593 29.5626 141.265 24.8107 142.273C20.0588 143.281 13.4555 148.238 12.6944 157.187C12.5298 158.997 12.5504 167.39 12.571 169.673C12.571 170.126 12.3858 170.537 12.0773 170.846C11.3367 171.545 9.73216 172.45 7.28422 170.866Z",
  stroke: "black",
  strokeWidth: 0.170492,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M8.60071 171.525L23.3707 174.939L27.0529 172.718L12.5709 169.673C12.5709 169.673 11.9743 172.574 8.60071 171.525Z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M31.4963 158.956L45.5874 162.041L48.5702 160.314L35.0345 157.248C35.0345 157.248 34.8699 159.038 31.4963 158.956Z",
  fill: "url(#paint2_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M351.773 82.8085L386.662 85.9147C387.361 85.9765 388.061 85.8119 388.657 85.4622L425.541 63.8627C425.911 63.6569 425.788 63.081 425.356 63.0398L377.034 52.9189L351.773 82.8085Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.699 70.7334L371.604 49.2779C372.879 48.5373 374.463 48.5373 375.738 49.2779L391.763 58.5965C392.854 59.2342 392.833 60.777 391.763 61.4147L355.476 82.3765C353.974 83.2405 352.144 83.2405 350.642 82.3765L334.699 73.1608C333.774 72.6259 333.774 71.2888 334.699 70.7334Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334 67.1129V72.0705H338.608H340.994L334 67.1129Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M391.763 58.5965L375.738 49.2779C374.463 48.5373 372.879 48.5373 371.604 49.2779L353.769 59.6456V82.9525C354.365 82.8703 354.941 82.6645 355.476 82.356L391.763 61.4147C392.854 60.7976 392.854 59.2342 391.763 58.5965Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.7 65.8169L371.604 44.3614C372.879 43.6208 374.463 43.6208 375.739 44.3614L391.764 53.68C392.854 54.3177 392.833 55.8606 391.764 56.4983L355.476 77.4601C353.975 78.3241 352.144 78.3241 350.642 77.4601L334.7 68.2649C333.774 67.7094 333.774 66.3723 334.7 65.8169Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.699 61.7233L371.604 40.2678C372.879 39.5272 374.463 39.5272 375.738 40.2678L391.763 49.5864C392.854 50.2241 392.833 51.7669 391.763 52.4046L355.476 73.3459C353.974 74.2099 352.144 74.2099 350.642 73.3459L334.699 64.1507C333.774 63.6158 333.774 62.2581 334.699 61.7233Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334 58.1028V63.0398H338.608H340.994L334 58.1028Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M391.763 49.5864L375.738 40.2678C374.463 39.5272 372.879 39.5272 371.604 40.2678L353.769 50.6355V73.9424C354.365 73.8602 354.941 73.6544 355.476 73.3459L391.763 52.4046C392.854 51.7875 392.854 50.2241 391.763 49.5864Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.7 56.8068L371.604 35.3513C372.879 34.6107 374.463 34.6107 375.739 35.3513L391.764 44.6699C392.854 45.3076 392.833 46.8505 391.764 47.4882L355.476 68.4294C353.975 69.2934 352.144 69.2934 350.642 68.4294L334.7 59.2342C333.774 58.6994 333.774 57.3417 334.7 56.8068Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.699 51.6229L371.604 30.1674C372.879 29.4268 374.463 29.4268 375.738 30.1674L391.763 39.4861C392.854 40.1238 392.833 41.6666 391.763 42.3043L355.476 63.2455C353.974 64.1095 352.144 64.1095 350.642 63.2455L334.699 54.0503C333.774 53.4949 333.774 52.1578 334.699 51.6229Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334 48.0024V52.9395H338.608H340.994L334 48.0024Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M391.763 39.4861L375.738 30.1674C374.463 29.4268 372.879 29.4268 371.604 30.1674L353.769 40.5352V63.8421C354.365 63.7598 354.941 63.5541 355.476 63.2455L391.763 42.3043C392.854 41.6666 392.854 40.1032 391.763 39.4861Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.7 46.7065L371.604 25.2509C372.879 24.5104 374.463 24.5104 375.739 25.2509L391.764 34.5696C392.854 35.2073 392.833 36.7501 391.764 37.3878L355.476 58.3291C353.975 59.193 352.144 59.193 350.642 58.3291L334.7 49.1338C333.774 48.599 333.774 47.2413 334.7 46.7065Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.284 48.8664C349.079 48.7224 348.935 48.4961 348.935 48.2287V37.0792C348.935 37.0792 349.058 28.0692 354.016 22.1036C358.973 16.138 367.263 12.4764 372.015 14.6157C376.767 16.7757 377.096 21.9184 377.034 24.5721C376.973 26.876 377.034 33.4588 377.034 35.2279C377.034 35.6804 376.849 36.1124 376.5 36.4004C376.273 36.5855 375.944 36.7707 375.492 36.8941C374.854 37.0792 374.155 37.0792 373.496 36.9353C373.023 36.8324 372.447 36.6678 371.995 36.4004C371.563 36.133 371.316 35.6599 371.316 35.1661V24.5927C371.316 24.5927 371.563 19.2648 366.811 20.2728C362.059 21.2807 355.456 26.2383 354.694 35.1867C354.53 36.997 354.55 45.3899 354.571 47.6733C354.571 48.1259 354.386 48.5373 354.077 48.8458C353.337 49.5453 351.732 50.4504 349.284 48.8664Z",
  stroke: "black",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M350.601 49.5247L365.371 52.9395L369.053 50.7178L354.571 47.6733C354.571 47.6733 353.974 50.5738 350.601 49.5247Z",
  fill: "url(#paint4_linear)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M-18.2267 69.8085L16.6617 72.9147C17.3611 72.9765 18.0605 72.8119 18.6571 72.4622L55.5408 50.8627C55.9111 50.6569 55.7877 50.081 55.3557 50.0398L7.03447 39.9189L-18.2267 69.8085Z",
  fill: "url(#paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-35.3006 57.7334L1.60373 36.2778C2.87913 35.5373 4.46309 35.5373 5.73849 36.2778L21.7633 45.5965C22.8535 46.2342 22.833 47.777 21.7633 48.4147L-14.5239 69.3765C-16.0256 70.2405 -17.8564 70.2405 -19.3581 69.3765L-35.3006 60.1608C-36.2263 59.6259 -36.2263 58.2888 -35.3006 57.7334Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5861 41.976V47.0982H14.3783L22.5861 41.976Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.7633 45.5965L5.73848 36.2778C4.46308 35.5373 2.87911 35.5373 1.60371 36.2778L-16.2313 46.6456V69.9525C-15.6348 69.8703 -15.0588 69.6645 -14.5239 69.356L21.7633 48.4147C22.8535 47.7976 22.8535 46.2342 21.7633 45.5965Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-35.3003 52.8169L1.60403 31.3614C2.87943 30.6208 4.4634 30.6208 5.7388 31.3614L21.7636 40.68C22.8539 41.3177 22.8333 42.8606 21.7636 43.4983L-14.5236 64.4601C-16.0253 65.3241 -17.8561 65.3241 -19.3578 64.4601L-35.3003 55.2649C-36.226 54.7094 -36.226 53.3723 -35.3003 52.8169Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-35.3006 48.7233L1.60373 27.2678C2.87913 26.5272 4.46309 26.5272 5.73849 27.2678L21.7633 36.5864C22.8535 37.2241 22.833 38.7669 21.7633 39.4046L-14.5239 60.3459C-16.0256 61.2099 -17.8564 61.2099 -19.3581 60.3459L-35.3006 51.1507C-36.2263 50.6158 -36.2263 49.2581 -35.3006 48.7233Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5861 32.9659V38.0881H14.3783L22.5861 32.9659Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.7633 36.5864L5.73848 27.2678C4.46308 26.5272 2.87911 26.5272 1.60371 27.2678L-16.2313 37.6355V60.9424C-15.6348 60.8602 -15.0588 60.6544 -14.5239 60.3459L21.7633 39.4046C22.8535 38.7875 22.8535 37.2241 21.7633 36.5864Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-35.3003 43.8068L1.60403 22.3513C2.87943 21.6107 4.4634 21.6107 5.7388 22.3513L21.7636 31.6699C22.8539 32.3076 22.8333 33.8505 21.7636 34.4882L-14.5236 55.4294C-16.0253 56.2934 -17.8561 56.2934 -19.3578 55.4294L-35.3003 46.2342C-36.226 45.6994 -36.226 44.3417 -35.3003 43.8068Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-35.3006 38.6229L1.60373 17.1674C2.87913 16.4268 4.46309 16.4268 5.73849 17.1674L21.7633 26.4861C22.8535 27.1238 22.833 28.6666 21.7633 29.3043L-14.5239 50.2455C-16.0256 51.1095 -17.8564 51.1095 -19.3581 50.2455L-35.3006 41.0503C-36.2263 40.4949 -36.2263 39.1578 -35.3006 38.6229Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5861 22.8656V27.9877H14.3783L22.5861 22.8656Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.7633 26.4861L5.73848 17.1674C4.46308 16.4268 2.87911 16.4268 1.60371 17.1674L-16.2313 27.5352V50.8421C-15.6348 50.7598 -15.0588 50.5541 -14.5239 50.2455L21.7633 29.3043C22.8535 28.6666 22.8535 27.1032 21.7633 26.4861Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-35.3003 33.7065L1.60403 12.2509C2.87943 11.5104 4.4634 11.5104 5.7388 12.2509L21.7636 21.5696C22.8539 22.2073 22.8333 23.7501 21.7636 24.3878L-14.5236 45.3291C-16.0253 46.193 -17.8561 46.193 -19.3578 45.3291L-35.3003 36.1338C-36.226 35.599 -36.226 34.2413 -35.3003 33.7065Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-20.7158 35.8664C-20.9215 35.7224 -21.0655 35.4961 -21.0655 35.2287V24.0792C-21.0655 24.0792 -20.9421 15.0692 -15.9845 9.10358C-11.0269 3.13799 -2.73675 -0.52364 2.01515 1.61574C6.76704 3.77569 7.09618 8.91844 7.03446 11.5721C6.97275 13.876 7.03446 20.4588 7.03446 22.2279C7.03446 22.6804 6.84932 23.1124 6.49962 23.4004C6.27334 23.5855 5.9442 23.7707 5.49164 23.8941C4.85394 24.0792 4.15452 24.0792 3.49625 23.9353C3.02312 23.8324 2.44714 23.6678 1.99457 23.4004C1.56258 23.133 1.31573 22.6599 1.31573 22.1661V11.5927C1.31573 11.5927 1.56258 6.26478 -3.18931 7.27276C-7.94121 8.28074 -14.5445 13.2383 -15.3056 22.1867C-15.4702 23.997 -15.4496 32.3899 -15.429 34.6733C-15.429 35.1259 -15.6142 35.5373 -15.9227 35.8458C-16.6633 36.5453 -18.2678 37.4504 -20.7158 35.8664Z",
  stroke: "black",
  strokeWidth: 0.170492,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M3.49628 23.9558L17.5874 27.0415L20.5702 25.3135L7.03449 22.2484C7.03449 22.2484 6.86992 24.0381 3.49628 23.9558Z",
  fill: "url(#paint6_linear)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M64.7733 141.809L99.6617 144.915C100.361 144.976 101.061 144.812 101.657 144.462L138.541 122.863C138.911 122.657 138.788 122.081 138.356 122.04L90.0345 111.919L64.7733 141.809Z",
  fill: "url(#paint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.6994 129.733L84.6037 108.278C85.8791 107.537 87.4631 107.537 88.7385 108.278L104.763 117.597C105.854 118.234 105.833 119.777 104.763 120.415L68.4761 141.377C66.9744 142.241 65.1436 142.241 63.6419 141.377L47.6994 132.161C46.7737 131.626 46.7737 130.289 47.6994 129.733Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47 126.113V131.07H51.6079H53.9941L47 126.113Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.586 113.976V119.098H97.3783L105.586 113.976Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.763 117.597L88.7385 108.278C87.4631 107.537 85.8791 107.537 84.6037 108.278L66.7687 118.646V141.953C67.3652 141.87 67.9412 141.665 68.4761 141.356L104.763 120.415C105.854 119.798 105.854 118.234 104.763 117.597Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.6997 124.817L84.604 103.361C85.8794 102.621 87.4634 102.621 88.7388 103.361L104.764 112.68C105.854 113.318 105.833 114.861 104.764 115.498L68.4764 136.46C66.9747 137.324 65.1439 137.324 63.6422 136.46L47.6997 127.265C46.774 126.709 46.774 125.372 47.6997 124.817Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.6994 120.723L84.6037 99.2678C85.8791 98.5272 87.4631 98.5272 88.7385 99.2678L104.763 108.586C105.854 109.224 105.833 110.767 104.763 111.405L68.4761 132.346C66.9744 133.21 65.1436 133.21 63.6419 132.346L47.6994 123.151C46.7737 122.616 46.7737 121.258 47.6994 120.723Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47 117.103V122.04H51.6079H53.9941L47 117.103Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.586 104.966V110.088H97.3783L105.586 104.966Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.763 108.586L88.7385 99.2678C87.4631 98.5272 85.8791 98.5272 84.6037 99.2678L66.7687 109.636V132.942C67.3652 132.86 67.9412 132.654 68.4761 132.346L104.763 111.405C105.854 110.788 105.854 109.224 104.763 108.586Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.6997 115.807L84.604 94.3513C85.8794 93.6107 87.4634 93.6107 88.7388 94.3513L104.764 103.67C105.854 104.308 105.833 105.85 104.764 106.488L68.4764 127.429C66.9747 128.293 65.1439 128.293 63.6422 127.429L47.6997 118.234C46.774 117.699 46.774 116.342 47.6997 115.807Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.6994 110.623L84.6037 89.1674C85.8791 88.4268 87.4631 88.4268 88.7385 89.1674L104.763 98.4861C105.854 99.1238 105.833 100.667 104.763 101.304L68.4761 122.246C66.9744 123.11 65.1436 123.11 63.6419 122.246L47.6994 113.05C46.7737 112.495 46.7737 111.158 47.6994 110.623Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47 107.002V111.939H51.6079H53.9941L47 107.002Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.586 94.8656V99.9877H97.3783L105.586 94.8656Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.763 98.4861L88.7385 89.1674C87.4631 88.4268 85.8791 88.4268 84.6037 89.1674L66.7687 99.5352V122.842C67.3652 122.76 67.9412 122.554 68.4761 122.246L104.763 101.304C105.854 100.667 105.854 99.1032 104.763 98.4861Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.6997 105.706L84.604 84.2509C85.8794 83.5104 87.4634 83.5104 88.7388 84.2509L104.764 93.5696C105.854 94.2073 105.833 95.7501 104.764 96.3878L68.4764 117.329C66.9747 118.193 65.1439 118.193 63.6422 117.329L47.6997 108.134C46.774 107.599 46.774 106.241 47.6997 105.706Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.2842 107.866C62.0785 107.722 61.9345 107.496 61.9345 107.229V96.0792C61.9345 96.0792 62.0579 87.0692 67.0155 81.1036C71.9731 75.138 80.2633 71.4764 85.0151 73.6157C89.767 75.7757 90.0962 80.9184 90.0345 83.5721C89.9728 85.876 90.0345 92.4588 90.0345 94.2279C90.0345 94.6804 89.8493 95.1124 89.4996 95.4004C89.2733 95.5855 88.9442 95.7707 88.4916 95.8941C87.8539 96.0792 87.1545 96.0792 86.4963 95.9352C86.0231 95.8324 85.4471 95.6678 84.9946 95.4004C84.5626 95.133 84.3157 94.6598 84.3157 94.1661V83.5927C84.3157 83.5927 84.5626 78.2648 79.8107 79.2728C75.0588 80.2807 68.4555 85.2383 67.6944 94.1867C67.5298 95.997 67.5504 104.39 67.571 106.673C67.571 107.126 67.3858 107.537 67.0773 107.846C66.3367 108.545 64.7322 109.45 62.2842 107.866Z",
  stroke: "black",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M63.6007 108.525L78.3707 111.939L82.0529 109.718L67.5709 106.673C67.5709 106.673 66.9743 109.574 63.6007 108.525Z",
  fill: "url(#paint8_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M86.4963 95.9558L100.587 99.0415L103.57 97.3135L90.0345 94.2484C90.0345 94.2484 89.8699 96.0381 86.4963 95.9558Z",
  fill: "url(#paint9_linear)"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M149.434 234.152L234.693 241.743C236.402 241.893 238.111 241.491 239.569 240.637L329.704 187.853C330.609 187.35 330.307 185.942 329.252 185.842L211.166 161.109L149.434 234.152Z",
  fill: "url(#paint10_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M107.709 204.643L197.895 152.211C201.011 150.401 204.882 150.401 207.999 152.211L247.16 174.983C249.824 176.542 249.774 180.312 247.16 181.87L158.483 233.096C154.813 235.207 150.339 235.207 146.669 233.096L107.709 210.575C105.447 209.268 105.447 206 107.709 204.643Z",
  fill: "#0C3273"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M106 195.795V207.911H117.261H123.092L106 195.795Z",
  fill: "#0C3273"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M249.171 166.136V178.653H229.113L249.171 166.136Z",
  fill: "#0A4AB7"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M247.16 174.983L207.999 152.211C204.882 150.401 201.011 150.401 197.895 152.211L154.31 177.547V234.504C155.768 234.303 157.175 233.8 158.482 233.046L247.16 181.87C249.824 180.362 249.824 176.542 247.16 174.983Z",
  fill: "#0A4AB7"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M197.946 140.282L107.761 192.714C107.761 192.714 107.761 192.714 107.761 192.714C105.564 194.033 105.564 197.206 107.761 198.524C107.761 198.524 107.761 198.525 107.761 198.525L146.72 220.995C150.358 223.088 154.794 223.088 158.433 220.995L197.946 140.282ZM197.946 140.282C201.031 138.491 204.864 138.491 207.95 140.282L247.11 163.055C249.707 164.574 249.66 168.249 247.11 169.77C247.11 169.77 247.109 169.77 247.109 169.77L158.433 220.995L197.946 140.282Z",
  fill: "#FFEEBC",
  stroke: "#FFBD00",
  strokeWidth: 0.2
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M107.709 182.624L197.895 130.192C201.011 128.382 204.882 128.382 207.999 130.192L247.16 152.965C249.824 154.523 249.774 158.293 247.16 159.852L158.483 211.027C154.813 213.139 150.339 213.139 146.669 211.027L107.709 188.556C105.447 187.249 105.447 183.931 107.709 182.624Z",
  fill: "#0C3273"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M106 173.777V185.842H117.261H123.092L106 173.777Z",
  fill: "#0C3273"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M249.171 144.117V156.634H229.113L249.171 144.117Z",
  fill: "#0A4AB7"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M247.16 152.965L207.999 130.192C204.882 128.382 201.011 128.382 197.895 130.192L154.31 155.529V212.485C155.768 212.284 157.175 211.781 158.482 211.027L247.16 159.852C249.824 158.344 249.824 154.523 247.16 152.965Z",
  fill: "#0A4AB7"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M107.76 170.696L107.76 170.696C105.564 171.965 105.564 175.186 107.76 176.455L107.76 170.696ZM107.76 170.696L197.946 118.264C201.031 116.472 204.864 116.472 207.95 118.264L247.11 141.036C249.706 142.555 249.66 146.23 247.11 147.751C247.11 147.751 247.11 147.751 247.109 147.751L158.433 198.926C154.794 201.02 150.358 201.02 146.72 198.926L107.76 176.455L107.76 170.696Z",
  fill: "#FFEEBC",
  stroke: "#FFBD00",
  strokeWidth: 0.2
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M107.709 157.942L197.895 105.509C201.011 103.7 204.882 103.7 207.999 105.509L247.16 128.282C249.824 129.84 249.774 133.611 247.16 135.169L158.483 186.344C154.813 188.456 150.339 188.456 146.669 186.344L107.709 163.873C105.447 162.516 105.447 159.249 107.709 157.942Z",
  fill: "#0C3273"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M106 149.094V161.159H117.261H123.092L106 149.094Z",
  fill: "#0C3273"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M249.171 119.434V131.952H229.113L249.171 119.434Z",
  fill: "#0A4AB7"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M247.16 128.282L207.999 105.509C204.882 103.7 201.011 103.7 197.895 105.509L154.31 130.846V187.802C155.768 187.601 157.175 187.098 158.482 186.344L247.16 135.169C249.824 133.611 249.824 129.79 247.16 128.282Z",
  fill: "#0A4AB7"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M107.76 146.013L107.76 146.013C105.564 147.282 105.564 150.504 107.76 151.772L107.76 146.013ZM107.76 146.013L197.946 93.5811C201.031 91.7894 204.864 91.7894 207.95 93.5811L247.11 116.354C249.706 117.872 249.66 121.547 247.11 123.068C247.11 123.068 247.11 123.068 247.109 123.068L158.433 174.243C154.794 176.337 150.358 176.337 146.72 174.243L107.76 151.772L107.76 146.013Z",
  fill: "#FFEEBC",
  stroke: "#FFBD00",
  strokeWidth: 0.2
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M143.351 151.205C142.848 150.853 142.496 150.3 142.496 149.647V122.4C142.496 122.4 142.798 100.382 154.913 85.8032C167.029 71.2248 187.288 62.2766 198.9 67.5047C210.513 72.7831 211.317 85.3508 211.166 91.8357C211.015 97.466 211.166 113.553 211.166 117.876C211.166 118.982 210.714 120.038 209.859 120.741C209.306 121.194 208.502 121.646 207.396 121.948C205.837 122.4 204.128 122.4 202.52 122.048C201.363 121.797 199.956 121.395 198.85 120.741C197.794 120.088 197.191 118.932 197.191 117.725V91.886C197.191 91.886 197.794 78.8659 186.182 81.3291C174.569 83.7924 158.432 95.9076 156.572 117.775C156.17 122.199 156.22 142.71 156.271 148.29C156.271 149.396 155.818 150.401 155.064 151.155C153.254 152.864 149.333 155.076 143.351 151.205Z",
  stroke: "black",
  strokeWidth: 1.3,
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M146.568 152.814L182.663 161.159L191.661 155.73L156.271 148.29C156.271 148.29 154.813 155.378 146.568 152.814Z",
  fill: "url(#paint11_linear)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M202.52 122.099L236.955 129.639L244.244 125.416L211.166 117.926C211.166 117.926 210.764 122.3 202.52 122.099Z",
  fill: "url(#paint12_linear)"
});

var _ref25 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M308.773 279.809L343.662 282.915C344.361 282.976 345.061 282.812 345.657 282.462L382.541 260.863C382.911 260.657 382.788 260.081 382.356 260.04L334.034 249.919L308.773 279.809Z",
  fill: "url(#paint13_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.699 267.733L328.604 246.278C329.879 245.537 331.463 245.537 332.738 246.278L348.763 255.596C349.854 256.234 349.833 257.777 348.763 258.415L312.476 279.377C310.974 280.241 309.144 280.241 307.642 279.377L291.699 270.161C290.774 269.626 290.774 268.289 291.699 267.733Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291 264.113V269.07H295.608H297.994L291 264.113Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.586 251.976V257.098H341.378L349.586 251.976Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M348.763 255.596L332.738 246.278C331.463 245.537 329.879 245.537 328.604 246.278L310.769 256.646V279.953C311.365 279.87 311.941 279.665 312.476 279.356L348.763 258.415C349.854 257.798 349.854 256.234 348.763 255.596Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.7 262.817L328.604 241.361C329.879 240.621 331.463 240.621 332.739 241.361L348.764 250.68C349.854 251.318 349.833 252.861 348.764 253.498L312.476 274.46C310.975 275.324 309.144 275.324 307.642 274.46L291.7 265.265C290.774 264.709 290.774 263.372 291.7 262.817Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.699 258.723L328.604 237.268C329.879 236.527 331.463 236.527 332.738 237.268L348.763 246.586C349.854 247.224 349.833 248.767 348.763 249.405L312.476 270.346C310.974 271.21 309.144 271.21 307.642 270.346L291.699 261.151C290.774 260.616 290.774 259.258 291.699 258.723Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291 255.103V260.04H295.608H297.994L291 255.103Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.586 242.966V248.088H341.378L349.586 242.966Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M348.763 246.586L332.738 237.268C331.463 236.527 329.879 236.527 328.604 237.268L310.769 247.636V270.942C311.365 270.86 311.941 270.654 312.476 270.346L348.763 249.405C349.854 248.788 349.854 247.224 348.763 246.586Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.7 253.807L328.604 232.351C329.879 231.611 331.463 231.611 332.739 232.351L348.764 241.67C349.854 242.308 349.833 243.85 348.764 244.488L312.476 265.429C310.975 266.293 309.144 266.293 307.642 265.429L291.7 256.234C290.774 255.699 290.774 254.342 291.7 253.807Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.699 248.623L328.604 227.167C329.879 226.427 331.463 226.427 332.738 227.167L348.763 236.486C349.854 237.124 349.833 238.667 348.763 239.304L312.476 260.246C310.974 261.11 309.144 261.11 307.642 260.246L291.699 251.05C290.774 250.495 290.774 249.158 291.699 248.623Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291 245.002V249.939H295.608H297.994L291 245.002Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.586 232.866V237.988H341.378L349.586 232.866Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M348.763 236.486L332.738 227.167C331.463 226.427 329.879 226.427 328.604 227.167L310.769 237.535V260.842C311.365 260.76 311.941 260.554 312.476 260.246L348.763 239.304C349.854 238.667 349.854 237.103 348.763 236.486Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.7 243.706L328.604 222.251C329.879 221.51 331.463 221.51 332.739 222.251L348.764 231.57C349.854 232.207 349.833 233.75 348.764 234.388L312.476 255.329C310.975 256.193 309.144 256.193 307.642 255.329L291.7 246.134C290.774 245.599 290.774 244.241 291.7 243.706Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M306.284 245.866C306.079 245.722 305.935 245.496 305.935 245.229V234.079C305.935 234.079 306.058 225.069 311.016 219.104C315.973 213.138 324.263 209.476 329.015 211.616C333.767 213.776 334.096 218.918 334.034 221.572C333.973 223.876 334.034 230.459 334.034 232.228C334.034 232.68 333.849 233.112 333.5 233.4C333.273 233.586 332.944 233.771 332.492 233.894C331.854 234.079 331.155 234.079 330.496 233.935C330.023 233.832 329.447 233.668 328.995 233.4C328.563 233.133 328.316 232.66 328.316 232.166V221.593C328.316 221.593 328.563 216.265 323.811 217.273C319.059 218.281 312.456 223.238 311.694 232.187C311.53 233.997 311.55 242.39 311.571 244.673C311.571 245.126 311.386 245.537 311.077 245.846C310.337 246.545 308.732 247.45 306.284 245.866Z",
  stroke: "black",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M307.601 246.525L322.371 249.939L326.053 247.718L311.571 244.673C311.571 244.673 310.974 247.574 307.601 246.525Z",
  fill: "url(#paint14_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M330.496 233.956L344.587 237.041L347.57 235.314L334.034 232.248C334.034 232.248 333.87 234.038 330.496 233.956Z",
  fill: "url(#paint15_linear)"
}));

var _ref26 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M53.7733 288.809L88.6617 291.915C89.3611 291.976 90.0605 291.812 90.6571 291.462L127.541 269.863C127.911 269.657 127.788 269.081 127.356 269.04L79.0345 258.919L53.7733 288.809Z",
  fill: "url(#paint16_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.6994 276.733L73.6037 255.278C74.8791 254.537 76.4631 254.537 77.7385 255.278L93.7633 264.596C94.8535 265.234 94.833 266.777 93.7633 267.415L57.4761 288.377C55.9744 289.241 54.1436 289.241 52.6419 288.377L36.6994 279.161C35.7737 278.626 35.7737 277.289 36.6994 276.733Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36 273.113V278.07H40.6079H42.9941L36 273.113Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.5861 260.976V266.098H86.3783L94.5861 260.976Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.7633 264.596L77.7385 255.278C76.4631 254.537 74.8791 254.537 73.6037 255.278L55.7687 265.646V288.953C56.3652 288.87 56.9412 288.665 57.4761 288.356L93.7633 267.415C94.8535 266.798 94.8535 265.234 93.7633 264.596Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.6997 271.817L73.604 250.361C74.8794 249.621 76.4634 249.621 77.7388 250.361L93.7636 259.68C94.8539 260.318 94.8333 261.861 93.7636 262.498L57.4764 283.46C55.9747 284.324 54.1439 284.324 52.6422 283.46L36.6997 274.265C35.774 273.709 35.774 272.372 36.6997 271.817Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.6994 267.723L73.6037 246.268C74.8791 245.527 76.4631 245.527 77.7385 246.268L93.7633 255.586C94.8535 256.224 94.833 257.767 93.7633 258.405L57.4761 279.346C55.9744 280.21 54.1436 280.21 52.6419 279.346L36.6994 270.151C35.7737 269.616 35.7737 268.258 36.6994 267.723Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36 264.103V269.04H40.6079H42.9941L36 264.103Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.5861 251.966V257.088H86.3783L94.5861 251.966Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.7633 255.586L77.7385 246.268C76.4631 245.527 74.8791 245.527 73.6037 246.268L55.7687 256.636V279.942C56.3652 279.86 56.9412 279.654 57.4761 279.346L93.7633 258.405C94.8535 257.788 94.8535 256.224 93.7633 255.586Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.6997 262.807L73.604 241.351C74.8794 240.611 76.4634 240.611 77.7388 241.351L93.7636 250.67C94.8539 251.308 94.8333 252.85 93.7636 253.488L57.4764 274.429C55.9747 275.293 54.1439 275.293 52.6422 274.429L36.6997 265.234C35.774 264.699 35.774 263.342 36.6997 262.807Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.6994 257.623L73.6037 236.167C74.8791 235.427 76.4631 235.427 77.7385 236.167L93.7633 245.486C94.8535 246.124 94.833 247.667 93.7633 248.304L57.4761 269.246C55.9744 270.11 54.1436 270.11 52.6419 269.246L36.6994 260.05C35.7737 259.495 35.7737 258.158 36.6994 257.623Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36 254.002V258.939H40.6079H42.9941L36 254.002Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.5861 241.866V246.988H86.3783L94.5861 241.866Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.7633 245.486L77.7385 236.167C76.4631 235.427 74.8791 235.427 73.6037 236.167L55.7687 246.535V269.842C56.3652 269.76 56.9412 269.554 57.4761 269.246L93.7633 248.304C94.8535 247.667 94.8535 246.103 93.7633 245.486Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.6997 252.706L73.604 231.251C74.8794 230.51 76.4634 230.51 77.7388 231.251L93.7636 240.57C94.8539 241.207 94.8333 242.75 93.7636 243.388L57.4764 264.329C55.9747 265.193 54.1439 265.193 52.6422 264.329L36.6997 255.134C35.774 254.599 35.774 253.241 36.6997 252.706Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.2842 254.866C51.0785 254.722 50.9345 254.496 50.9345 254.229V243.079C50.9345 243.079 51.0579 234.069 56.0155 228.104C60.9731 222.138 69.2633 218.476 74.0151 220.616C78.767 222.776 79.0962 227.918 79.0345 230.572C78.9728 232.876 79.0345 239.459 79.0345 241.228C79.0345 241.68 78.8493 242.112 78.4996 242.4C78.2733 242.586 77.9442 242.771 77.4916 242.894C76.8539 243.079 76.1545 243.079 75.4963 242.935C75.0231 242.832 74.4471 242.668 73.9946 242.4C73.5626 242.133 73.3157 241.66 73.3157 241.166V230.593C73.3157 230.593 73.5626 225.265 68.8107 226.273C64.0588 227.281 57.4555 232.238 56.6944 241.187C56.5298 242.997 56.5504 251.39 56.571 253.673C56.571 254.126 56.3858 254.537 56.0773 254.846C55.3367 255.545 53.7322 256.45 51.2842 254.866Z",
  stroke: "black",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M52.6007 255.525L67.3707 258.939L71.0529 256.718L56.5709 253.673C56.5709 253.673 55.9743 256.574 52.6007 255.525Z",
  fill: "url(#paint17_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M75.4963 242.956L89.5874 246.041L92.5702 244.314L79.0345 241.248C79.0345 241.248 78.8699 243.038 75.4963 242.956Z",
  fill: "url(#paint18_linear)"
}));

var _ref27 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M293.773 152.809L328.662 155.915C329.361 155.976 330.061 155.812 330.657 155.462L367.541 133.863C367.911 133.657 367.788 133.081 367.356 133.04L319.034 122.919L293.773 152.809Z",
  fill: "url(#paint19_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.699 140.733L313.604 119.278C314.879 118.537 316.463 118.537 317.738 119.278L333.763 128.597C334.854 129.234 334.833 130.777 333.763 131.415L297.476 152.377C295.974 153.241 294.144 153.241 292.642 152.377L276.699 143.161C275.774 142.626 275.774 141.289 276.699 140.733Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276 137.113V142.07H280.608H282.994L276 137.113Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.586 124.976V130.098H326.378L334.586 124.976Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333.763 128.597L317.738 119.278C316.463 118.537 314.879 118.537 313.604 119.278L295.769 129.646V152.953C296.365 152.87 296.941 152.665 297.476 152.356L333.763 131.415C334.854 130.798 334.854 129.234 333.763 128.597Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.7 135.817L313.604 114.361C314.879 113.621 316.463 113.621 317.739 114.361L333.764 123.68C334.854 124.318 334.833 125.861 333.764 126.498L297.476 147.46C295.975 148.324 294.144 148.324 292.642 147.46L276.7 138.265C275.774 137.709 275.774 136.372 276.7 135.817Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.699 131.723L313.604 110.268C314.879 109.527 316.463 109.527 317.738 110.268L333.763 119.586C334.854 120.224 334.833 121.767 333.763 122.405L297.476 143.346C295.974 144.21 294.144 144.21 292.642 143.346L276.699 134.151C275.774 133.616 275.774 132.258 276.699 131.723Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276 128.103V133.04H280.608H282.994L276 128.103Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.586 115.966V121.088H326.378L334.586 115.966Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333.763 119.586L317.738 110.268C316.463 109.527 314.879 109.527 313.604 110.268L295.769 120.636V143.942C296.365 143.86 296.941 143.654 297.476 143.346L333.763 122.405C334.854 121.788 334.854 120.224 333.763 119.586Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.7 126.807L313.604 105.351C314.879 104.611 316.463 104.611 317.739 105.351L333.764 114.67C334.854 115.308 334.833 116.85 333.764 117.488L297.476 138.429C295.975 139.293 294.144 139.293 292.642 138.429L276.7 129.234C275.774 128.699 275.774 127.342 276.7 126.807Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.699 121.623L313.604 100.167C314.879 99.4268 316.463 99.4268 317.738 100.167L333.763 109.486C334.854 110.124 334.833 111.667 333.763 112.304L297.476 133.246C295.974 134.11 294.144 134.11 292.642 133.246L276.699 124.05C275.774 123.495 275.774 122.158 276.699 121.623Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276 118.002V122.939H280.608H282.994L276 118.002Z",
  fill: "#0C3273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.586 105.866V110.988H326.378L334.586 105.866Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333.763 109.486L317.738 100.167C316.463 99.4268 314.879 99.4268 313.604 100.167L295.769 110.535V133.842C296.365 133.76 296.941 133.554 297.476 133.246L333.763 112.304C334.854 111.667 334.854 110.103 333.763 109.486Z",
  fill: "#0A4AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.7 116.706L313.604 95.2509C314.879 94.5104 316.463 94.5104 317.739 95.2509L333.764 104.57C334.854 105.207 334.833 106.75 333.764 107.388L297.476 128.329C295.975 129.193 294.144 129.193 292.642 128.329L276.7 119.134C275.774 118.599 275.774 117.241 276.7 116.706Z",
  fill: "#FFEEBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.284 118.866C291.079 118.722 290.935 118.496 290.935 118.229V107.079C290.935 107.079 291.058 98.0692 296.016 92.1036C300.973 86.138 309.263 82.4764 314.015 84.6157C318.767 86.7757 319.096 91.9184 319.034 94.5721C318.973 96.876 319.034 103.459 319.034 105.228C319.034 105.68 318.849 106.112 318.5 106.4C318.273 106.586 317.944 106.771 317.492 106.894C316.854 107.079 316.155 107.079 315.496 106.935C315.023 106.832 314.447 106.668 313.995 106.4C313.563 106.133 313.316 105.66 313.316 105.166V94.5927C313.316 94.5927 313.563 89.2648 308.811 90.2728C304.059 91.2807 297.456 96.2383 296.694 105.187C296.53 106.997 296.55 115.39 296.571 117.673C296.571 118.126 296.386 118.537 296.077 118.846C295.337 119.545 293.732 120.45 291.284 118.866Z",
  stroke: "black",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M292.601 119.525L307.371 122.939L311.053 120.718L296.571 117.673C296.571 117.673 295.974 120.574 292.601 119.525Z",
  fill: "url(#paint20_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.28,
  d: "M315.496 106.956L329.587 110.041L332.57 108.314L319.034 105.248C319.034 105.248 318.87 107.038 315.496 106.956Z",
  fill: "url(#paint21_linear)"
}));

var _ref28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 9.78247,
  y1: 191.441,
  x2: 83.7594,
  y2: 191.441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 8.59501,
  y1: 172.309,
  x2: 27.0611,
  y2: 172.309,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 31.4998,
  y1: 159.635,
  x2: 48.5759,
  y2: 159.635,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 351.782,
  y1: 69.4412,
  x2: 425.759,
  y2: 69.4412,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 350.595,
  y1: 50.309,
  x2: 369.061,
  y2: 50.309,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: -18.2175,
  y1: 56.4412,
  x2: 55.7594,
  y2: 56.4412,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 3.49984,
  y1: 24.6351,
  x2: 20.5759,
  y2: 24.6351,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 64.7825,
  y1: 128.441,
  x2: 138.759,
  y2: 128.441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 63.595,
  y1: 109.309,
  x2: 82.0611,
  y2: 109.309,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 86.4998,
  y1: 96.6351,
  x2: 103.576,
  y2: 96.6351,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 149.456,
  y1: 201.485,
  x2: 330.238,
  y2: 201.485,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0A4AB7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0A4AB7",
  stopOpacity: 0.26
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 146.554,
  y1: 154.73,
  x2: 191.681,
  y2: 154.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 202.528,
  y1: 123.759,
  x2: 244.258,
  y2: 123.759,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 308.782,
  y1: 266.441,
  x2: 382.759,
  y2: 266.441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 307.595,
  y1: 247.309,
  x2: 326.061,
  y2: 247.309,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 330.5,
  y1: 234.635,
  x2: 347.576,
  y2: 234.635,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 53.7825,
  y1: 275.441,
  x2: 127.759,
  y2: 275.441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: 52.595,
  y1: 256.309,
  x2: 71.0611,
  y2: 256.309,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: 75.4998,
  y1: 243.635,
  x2: 92.5759,
  y2: 243.635,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: 293.782,
  y1: 139.441,
  x2: 367.759,
  y2: 139.441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: 292.595,
  y1: 120.309,
  x2: 311.061,
  y2: 120.309,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear",
  x1: 315.5,
  y1: 107.635,
  x2: 332.576,
  y2: 107.635,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})));

function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 292,
    viewBox: "0 0 360 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.a1e09a00f50dd6bf9680bc42a110f116.svg";
export { ForwardRef as ReactComponent };